import { QueryClient } from 'react-query';

// root level query client
export default new QueryClient();
